import {gql} from '@apollo/client'

// NOTE: This admin-facing GraphQL surface does not exist yet in the backend.
// Only the public/unauthenticated onboarding queries live under
// `api/graphiql/agent_onboarding`. This query is written against the shape we
// expect an admin CRUD app (e.g. `api/graphiql/organization` or a new
// `onboarding_config` app) to expose. See the frontend task report for the
// exact backend follow-up needed.
export const GET_ONBOARDING_CONFIG_BY_ORGANIZATION = gql`
  query onboardingConfigByOrganization($organization: ID!) {
    onboardingConfigByOrganization(organization: $organization) {
      id
      isActive
      signatureForms {
        id
        name
      }
      stepMessages {
        id
        stepKey
        message
        isActive
      }
      requiredDocuments {
        id
        documentType
        context
        isRequired
      }
    }
  }
`

// Available signature forms for a given organization, to populate the
// Agreements/Consents multi-select. Extends the existing
// `allSignatureForms` query (see `signatureFormsApiQueries.ts`) with an
// `organization` filter. Backend exposes it as a plain String exact-match
// filter (SignatureFormFilter.filter_organization), not a Relay Global ID —
// keep this variable typed as String, not ID.
export const GET_SIGNATURE_FORMS_BY_ORGANIZATION = gql`
  query allSignatureForms($organization: String!, $status: String) {
    allSignatureForms(organization: $organization, status: $status) {
      edges {
        node {
          id
          name
          description
          status
        }
      }
    }
  }
`
